// drawer/tabs/ExploitationTimelineTab.tsx
import { ExploitsTimelineComponent } from '@/sections/threats/drawer/components';
import type { EnrichedVulnerability } from '@/sections/threats/types';

interface ExploitationTimelineTabProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * Exploitation timeline tab content
 */
export function ExploitationTimelineTab({
  threatIntel,
}: ExploitationTimelineTabProps) {
  return <ExploitsTimelineComponent threatIntel={threatIntel} />;
}
